import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/series';
import Container from '../../containers/admin';
import Root from '../../components/root';

export default function PageSeries() {
  return (
    <Root title={PAGE_TITLE.SERIES}>
      <Container>
        <Component />
      </Container>
    </Root>
  );
};
